import { TDocument, TDocumentData } from "../models";

export function createSyntheticPrimaryData(
  documentType: string,
): TDocumentData {
  return {
    id: "",
    verificationDocument: "",
    dataId: documentType,
    type: "binary",
    dataBase64: "",
    data: {},
    dataLink: "",
    document: "",
  };
}

export function createPlaceholderDocument(documentType: string): TDocument {
  return {
    document: {
      documentId: "",
      documentType,
      declineReason: [],
      warnings: [],
    },
    data: [],
  };
}

export function createPendingDocument(documentType: string): TDocument {
  return {
    ...createPlaceholderDocument(documentType),
    data: [createSyntheticPrimaryData(documentType)],
  };
}

export function isPendingDocument(document: TDocument): boolean {
  return document.document.documentId === "";
}

export function findPrimaryDocumentData(
  document: TDocument,
): TDocumentData | undefined {
  return document.data.find(
    (entry) =>
      entry.type === "binary" &&
      entry.dataId === document.document.documentType,
  );
}

export function getEditablePrimaryDocumentData(
  document: TDocument,
): TDocumentData {
  return (
    findPrimaryDocumentData(document) ??
    createSyntheticPrimaryData(document.document.documentType)
  );
}
